<script>
  import { onMount, onDestroy } from 'svelte';

  export let items = [];
  export let selectedValues = [];
  export let disabled = false;
  export let placeholder = 'Select';

  let open = false;
  let container;

  function toggleOpen() {
    if (disabled) return;
    open = !open;
  }

  function normalizeId(value) {
    if (value === undefined || value === null) return '';
    if (typeof value === 'object') {
      if (value.$oid && typeof value.$oid === 'string') return value.$oid;
      if (value._id) return normalizeId(value._id);
      if (typeof value.toString === 'function') {
        const s = value.toString();
        if (typeof s === 'string' && /^[a-fA-F0-9]{24}$/.test(s)) return s;
        return String(s || '');
      }
      return '';
    }
    return String(value);
  }

  function isSelected(value) {
    if (!Array.isArray(selectedValues)) return false;
    const needle = normalizeId(value);
    // Normalize haystack lazily to avoid mutating parent data
    return selectedValues.some((v) => normalizeId(v) === needle);
  }

  function toggleValue(value) {
    if (disabled) return;
    const val = normalizeId(value);
    const current = Array.isArray(selectedValues) ? [...selectedValues.map((v) => normalizeId(v))] : [];
    const idx = current.indexOf(val);
    if (idx === -1) {
      current.push(val);
    } else {
      current.splice(idx, 1);
    }
    selectedValues = current;
  }

  function handleClickOutside(e) {
    if (!open) return;
    if (container && !container.contains(e.target)) {
      open = false;
    }
  }

  onMount(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onDestroy(() => {
    document.removeEventListener('click', handleClickOutside);
  });

  $: selectedCount = Array.isArray(selectedValues) ? selectedValues.length : 0;
</script>

<div class="relative" bind:this={container}>
  <button
    type="button"
    class="h-8 w-full border px-2 p-0 rounded text-sm dark:bg-gray-700 dark:border-gray-600 text-gray-800 dark:text-gray-100 bg-white flex items-center justify-between"
    class:opacity-75={disabled}
    class:cursor-not-allowed={disabled}
    aria-haspopup="listbox"
    aria-expanded={open}
    on:click={toggleOpen}
    disabled={disabled}
  >
    <span class="truncate">
      {#if selectedCount === 0}
        {placeholder}
      {:else}
        {selectedCount} selected
      {/if}
    </span>
    <svg class="w-4 h-4 ml-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg>
  </button>

  {#if open}
    <div
      class="absolute z-50 mt-1 w-full max-h-60 overflow-auto border rounded bg-white dark:bg-gray-800 dark:border-gray-700 shadow"
      role="listbox"
      aria-multiselectable="true"
    >
      {#each items as item}
        <label class="flex items-center gap-2 px-2 py-1 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer select-none">
          <input
            type="checkbox"
            class="h-4 w-4 text-sky-600 focus:ring-sky-500 border-gray-300 rounded"
            checked={isSelected(item.value)}
            on:change={() => toggleValue(item.value)}
            disabled={disabled}
          />
          <span class="text-sm text-gray-900 dark:text-gray-100">{item.label}</span>
        </label>
      {/each}
      {#if items.length === 0}
        <div class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">No options</div>
      {/if}
    </div>
  {/if}
</div>

<style>
</style>


